import axios from 'axios';

export interface ApiClientOptions {
  baseURL: string;
}

export const axiosInstance = axios.create({
  withCredentials: true,
});

export const configureApiClient = (options: ApiClientOptions) => {
  const { baseURL } = options;

  if (!baseURL) {
    throw new Error('configureApiClient requires a non-empty baseURL');
  }

  axiosInstance.defaults.baseURL = baseURL;
};
